module.exports = "../../app/cells/components/new_button_follow_cell.rb";